// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Home';
import SignIn from './Account/SignIn';
import SignOut from './Account/SignOut';
import Game from './test/GuessingGame';
import ProtectedRoute from './Account/ProtectedRoute';
import AmplifyProvider from './AmplifyProvider';
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import Spacer from './components/Spacer';
import { Box } from '@mui/material';
//import Blog from './Block/Blog';
//import News from './Block/News';
import BlockHome from './pages/Home';
import CouponsPage from './pages/CouponsPage';
import Store from './pages/StoreEntry';
import QrCodePage from './pages/QrCodePage';
import Account from './Account/AccountPage';
import Barcode from './Account/BarcodePage';
import RegisterSmaregiAccount from './Account/RegisterSmaregiAccount'
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { TitleProvider } from './TitleContext';


import { GoogleMapsLoaderProvider } from './GoogleMapsLoaderContext';

function App() {
  return (
    <AmplifyProvider>
      <TitleProvider>
      <Router>
      <GoogleMapsLoaderProvider>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', overflow: 'hidden', backgroundColor: '#E0E0E0' }}> {/* Prevent scrolling of the entire page */}
          <Box sx={{ position: 'sticky', top: 0, zIndex: 1000, width: '100%' }}>
            <Navbar />
          </Box>
          <Box sx={{ flexGrow: 1, overflowY: 'auto', paddingBottom: { xs: '72px', sm: '56px' } }}> {/* Allow scrolling for the content only */}
            <Spacer height={64} />
            <Routes>
              <Route path="/siginhome" element={<Home />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/check-signout" element={<SignOut />} />
              <Route path="/" element={<BlockHome />} />
              <Route path="/game" element={<ProtectedRoute> <Game /> </ProtectedRoute>}/>
              <Route path="/coupons" element={<ProtectedRoute> <CouponsPage/> </ProtectedRoute>}/>
              <Route path="/store-entry" element={<ProtectedRoute><Store/></ProtectedRoute>}/>
              <Route path="/store-entry/qr-code/:storeName" element={<ProtectedRoute><QrCodePage/></ProtectedRoute>} />
              <Route path="/account" element={<ProtectedRoute><Account/></ProtectedRoute>}/>
              <Route path="/account/barcode" element={<ProtectedRoute><Barcode/></ProtectedRoute>}/>
              <Route path="/register-smaregi" element={<ProtectedRoute><RegisterSmaregiAccount/></ProtectedRoute>}/>
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
            </Routes>
          </Box>
          <Box sx={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 1000 }}> {/* Fix BottomNav to bottom */}
            <BottomNav />
          </Box>
        </Box>
        </GoogleMapsLoaderProvider>
      </Router>
      </TitleProvider>
    </AmplifyProvider>
  );
}

export default App;
